export enum TipStatusPaymentEnum {
  PENDING = 1,
  ACCREDITATED = 2,
  ERROR = 3,
}

export enum TransactionStatusEnum {
  UNPROCESSED = 0, // Cuando tenemos el earning pero todavía no corre el cron que genera transacción
  REGISTERED = 1, // Cuando el cron ya generó la transacción
  PENDING = 2, // Cuando la transacción se está procesando
  REJECTED = 3, // Cuando la transacción es rechazada
  ACCREDITATED = 4, // Cuando la transacción se ha pagado
  FAILED = 5, // Cuando la transacción falla (entra en proceso de reintentos)
  MAX_ATTEMPTS_REACHED = 6, // Cuando llegó al límite de reintentos
  PENDING_EPAGOS = 7,
  CLOVER_PENDING = 8,
  CLOVER_PROCESSING = 9,
  /** Retenida Clover (recaudador); en UI se muestra como acreditada */
  CLOVER_RETAINED = 10,
}

export function isAccreditatedLikeStatus(status: TransactionStatusEnum | number): boolean {
  return (
    status === TransactionStatusEnum.ACCREDITATED ||
    status === TransactionStatusEnum.CLOVER_RETAINED
  );
}
